import { useState, useEffect } from "react";

const useIsVisible = (ref) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (!ref.current) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      {
        threshold: 0.1, // Trigger when 10% of the element is visible
      }
    );

    observer.observe(ref.current);

    // Cleanup observer on component unmount
    return () => {
      observer.disconnect();
    };
  }, [ref]);

  return isVisible;
};

export default useIsVisible;
